import * as api from '../../api/api';
import { browserHistory } from 'react-router';
import * as types from '../constants/addressConstants';
import { reset } from 'redux-form';
import { getLastSavedRoute } from '../../util/routeHelper';

export function updateAddress(jobId, values) {
	return function (dispatch) {
		dispatch(updateJobAddressDetailsBegin());

		return api.post(`/jobs/${jobId}/address/update`, values).then(function () {
			browserHistory.push(getLastSavedRoute());
			dispatch(updateJobAddressDetailsSuccess());
		});
	};
}

export function updateContacts(jobId, values) {
	return function (dispatch) {
		dispatch(updateJobAddressDetailsBegin());

		return api.post(`/jobs/${jobId}/contact/update`, values).then(function () {
			if (!values.sendSMS)
				browserHistory.push(getLastSavedRoute());

			dispatch(updateJobAddressDetailsSuccess(values.sendSMS));
		});
	};
}

export function addAddress(jobId, values) {
	return function (dispatch) {
		dispatch(updateJobAddressDetailsBegin());

		return api.post(`/jobs/${jobId}/address/add`, values).then(function () {
			browserHistory.push(getLastSavedRoute());
			dispatch(updateJobAddressDetailsSuccess());
		});
	};
}

export function getLocalities(locality) {
	return function (dispatch) {
		return api.get(`/masterdata/localities/${locality}`).then(function (response) {
			dispatch(getLocalitiesSuccess(response));
		});
	};
}

export function getJobAddressDetails(jobId) {
	return function (dispatch) {
		dispatch(getJobAddressDetailsBegin());

		return api.get(`/booking/${jobId}/merchantinfo`).then(function (response) {
			dispatch(getJobAddressDetailsSuccess(response));
		});
	};
}

export function clearAddressDetails() {
	return function (dispatch) {
		dispatch(reset('contactdetails'));
	};
}

export function getLocalitiesSuccess(localities) {
	return {
		type: types.GET_LOCALITIES_SUCCESS,
		response: localities
	};
}

export function getJobAddressDetailsBegin() {
	return {
		type: types.GET_JOB_ADDRESS_DETAILS_BEGIN,
	};
}

export function getJobAddressDetailsSuccess(jobDetails) {
	return {
		type: types.GET_JOB_ADDRESS_DETAILS_SUCCCESS,
		response: jobDetails
	};
}

export function updateJobAddressDetailsBegin() {
	return {
		type: types.UPDATE_JOB_ADDRESS_DETAILS_BEGIN,
	};
}

export function updateJobAddressDetailsSuccess(smsSent) {
	return {
		type: types.UPDATE_JOB_ADDRESS_DETAILS_SUCCCESS,
		smsSent: smsSent
	};
}

export function clearLocalities() {
	return {
		type: types.CLEAR_LOCALITIES
	};
}

export function getAddressChangeStatus(booking) {
	const hasPendingPrimaryAddress = booking.details.primaryAddressChangeStatusID === types.ADDRESS_CHANGE_STATUSES.PENDING_APPROVAL ||
		booking.details.primaryAddressChangeStatusID === types.ADDRESS_CHANGE_STATUSES.PENDING_FURTHER_INFO;

	const hasPendingDeliveryAddress = booking.details.deliveryAddressChangeStatusID === types.ADDRESS_CHANGE_STATUSES.PENDING_APPROVAL ||
		booking.details.deliveryAddressChangeStatusID === types.ADDRESS_CHANGE_STATUSES.PENDING_FURTHER_INFO;

	const hasPendingChanges = hasPendingPrimaryAddress || hasPendingDeliveryAddress;

	return {
		hasPendingPrimaryAddress,
		hasPendingDeliveryAddress,
		hasPendingChanges
	};
}


// WEBPACK FOOTER //
// ./app/address/actions/addressActions.js